import React from "react";

import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Popconfirm } from "@mapmycustomers/ui";

import styles from "./ActionPopconfirm.module.scss";

interface Props {
  children: React.ReactNode;
  isFilterEmpty: boolean;
  onDelete: () => void;
}

const ActionPopconfirm: React.FC<Props> = ({ children, isFilterEmpty, onDelete }) => {
  const intl = useIntl();
  return (
    <Popconfirm
      cancelButtonProps={{ className: styles.cancelButton }}
      cancelText={intl.formatMessage({
        id: "savedFilters.emptyFilter.errorPopconfirm.cancelText",
        defaultMessage: "Cancel",
        description: "Cancel text for errored popconfirm on savedd filters",
      })}
      description={intl.formatMessage({
        id: "savedFilters.emptyFilter.errorPopconfirm.title",
        defaultMessage:
          "Unable to update this filter as no filter rules are applied. You can delete this saved filter or add another rule to update it.",
        description: "Title for errored popconfirm on savedd filters",
      })}
      disabled={!isFilterEmpty}
      icon={<FontAwesomeIcon className={styles.redInfoIcon} icon={faExclamationCircle} />}
      okButtonProps={{ className: styles.deleteFilterButton }}
      okText={intl.formatMessage({
        id: "savedFilters.emptyFilter.errorPopconfirm.okText",
        defaultMessage: "Delete saved filter",
        description: "Ok text for errored popconfirm on savedd filters",
      })}
      onConfirm={onDelete}
      overlayClassName={styles.container}
    >
      {children}
    </Popconfirm>
  );
};

export default ActionPopconfirm;
